import { Data } from '../signup-data/DATA';
import { getFlatSignupDataValueMap, getSignupDataValue } from '../store/signup-data/selectors';
import { getAmplitudeEventBody } from '../hubspot-forms/getAmplitudeEventBody';
import { getRouteParams } from '../routing/getRouteParams';
import { IdentityVerificationMethod } from '../tracking/IdentityVerificationMethod';
import { isCodeVerificationSignup } from '../app/verificationTypeSelectors';
import { getQueryParamsNoSignupData } from '../signup-data/getQueryParamsNoSignupData';
import { getQueryParamsNoEmbedderOptions } from '../routing/getQueryParamsNoEmbedderOptions';
import { getPreferredReferrer } from '../i18n/ReferrerUtils';
import { getImpactAdditionalParams } from '../utils/affiliateUtils';
import { endpointForwardedUtms } from '../utm/utmHelpers';
export const getCompleteVerificationBody = state => {
  const signupData = getFlatSignupDataValueMap(state);
  const {
    queryParams
  } = getRouteParams();
  const howUtms = endpointForwardedUtms(queryParams);
  const queryParamsWithoutSignupData = getQueryParamsNoSignupData(queryParams, signupData);
  const queryParamsNoEmbedderOptions = getQueryParamsNoEmbedderOptions(queryParamsWithoutSignupData);
  const email = getSignupDataValue(state, Data.Email);
  const token = getSignupDataValue(state, Data.Token);
  const code = getSignupDataValue(state, Data.CodeVerification);
  const params = Object.keys(queryParamsNoEmbedderOptions).filter(key => key !== 'gates').reduce((res, key) => Object.assign({}, res, {
    [key]: queryParamsNoEmbedderOptions[key]
  }), {});
  const verificationMethod = isCodeVerificationSignup(state) ? IdentityVerificationMethod.CodeVerification : IdentityVerificationMethod.EmailVerification;
  return Object.assign({
    email
  }, token && {
    token
  }, {}, code && {
    code
  }, {
    additionalUrlParams: Object.assign({}, params, {}, howUtms, {}, getImpactAdditionalParams(), {
      preReferrer: getPreferredReferrer()
    }),
    verificationMethod
  }, getAmplitudeEventBody(state));
};